export default __webpack_public_path__ + "static/quotewall-6f37a6a5f4e3eea3fbeed193dbbb275e.gif";